import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jobData: {
        requisitionID: "",
        positionNumber: "",
        positionTitle: "",
        location: "",
        closingDate: "",
        workHours: "",
        workDays: "",
        payRate: "",
        employmentType: "",
        sensitive: "",
        department: ""
    },
    status: "idle",
    error: null
};

export const jobDataSlice = createSlice({
    name: "jobDataSlice",
    initialState,
    reducers: {
        setReqID: (state, action) => {
            state.jobData.requisitionID = action.payload
        },
        setJobData: (state, action) => {
            state.jobData = action.payload;
        },
        resetJobData: (state) => {
            state.jobData = {
                requisitionID: "",
                positionNumber: "",
                positionTitle: "",
                location: "",
                closingDate: "",
                workHours: "",
                workDays: "",
                payRate: "",
                employmentType: "",
                sensitive: "",
                department: ""
            };
        }
    }
});

export const { setJobData, resetJobData, setReqID } = jobDataSlice.actions;

export const selectedJobData = (state) => state.jobDataSlice.jobData;
